// extracted by extract-css-chunks-webpack-plugin
module.exports = {"backToTop":"stickyIconSet__backToTop","chatbot":"stickyIconSet__chatbot","chatDialog":"stickyIconSet__chatDialog","dialogPointer":"stickyIconSet__dialogPointer"};